var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-main-container" }, [
    _c(
      "div",
      { staticClass: "boss-main-wrap boss-main-content-wrap" },
      [
        _c("setting-header", {
          attrs: {
            breadcrumbs: [{ name: "各種設定" }],
            title: "閲覧制限用IPアドレス設定",
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "grid-x align-justify" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "medium-3 cell" }, [
            _c("div", { staticClass: "float-right" }, [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: {
                        content: _vm.isOverLengthIpAddresses()
                          ? "IPアドレスは30件までしか登録できません。"
                          : "",
                      },
                      expression:
                        "{ content: isOverLengthIpAddresses() ? 'IPアドレスは30件までしか登録できません。' : '' }",
                    },
                  ],
                  staticClass: "boss-button pega-button boss-button-new",
                  attrs: {
                    disabled: _vm.isOverLengthIpAddresses(),
                    "data-test": "add-ip-address-button",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.addIpAddress()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "boss-icon-new" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "boss-button-new-text" }, [
                    _vm._v("IPアドレスを追加"),
                  ]),
                ]
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm._l(_vm.ipAddresses, function (_, index) {
          return _c("form-item", {
            key: index,
            attrs: {
              maxlength: "15",
              label: _vm._f("label")(index + 1),
              "data-test": "ip-address-form-" + index,
              "class-name": !_vm.isIpAddressFormat(_vm.ipAddresses[index])
                ? "pega-width-auto is-invalid-input"
                : "pega-width-auto",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function () {
                    return [_c("small", [_vm._v("※半角15文字以内")])]
                  },
                  proxy: true,
                },
                {
                  key: "error",
                  fn: function () {
                    return [
                      !_vm.isIpAddressFormat(_vm.ipAddresses[index])
                        ? _c("validation-label", {
                            attrs: {
                              label:
                                "IPアドレスの形式に沿って入力してください。\n（例）198.51.100.0",
                              "data-test": "invalid-ip-address-" + index,
                            },
                          })
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
            model: {
              value: _vm.ipAddresses[index],
              callback: function ($$v) {
                _vm.$set(_vm.ipAddresses, index, $$v)
              },
              expression: "ipAddresses[index]",
            },
          })
        }),
        _vm._v(" "),
        _c(
          "form-button-area",
          [
            _c("form-confirm-button", {
              attrs: {
                "is-disabled": _vm.isDisabledRegisterButton,
                "submit-label": "設定する",
                "data-test": "confirm-button",
              },
              on: { "submit-event": _vm.registerIpAddresses },
            }),
          ],
          1
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "medium-9 cell" }, [
      _c("p", [
        _vm._v(
          "この企業様管理画面の閲覧を許可するIPアドレスの設定を行います。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n          ※IPアドレスは３０個まで登録できます。\n        "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }